import { render } from "./ListSegmentationEditor.vue?vue&type=template&id=20c3aa0f&scoped=true"
import script from "./ListSegmentationEditor.vue?vue&type=script&lang=ts"
export * from "./ListSegmentationEditor.vue?vue&type=script&lang=ts"

import "./ListSegmentationEditor.vue?vue&type=style&index=0&id=20c3aa0f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-20c3aa0f"

export default script